module.exports = __webpack_public_path__ + "img/in_game.0d49772a.png";